import { frontendURL } from 'dashboard/helper/URLHelper';

const FiscalIndex = () => import('./pages/FiscalIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/fiscal'),
      name: 'fiscal_index',
      component: FiscalIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
